import React from "react";
import styled from "styled-components";
import featureFlags from "utils/featureFlags";
import hexToRgba from "utils/hexToRgba";

const TabToggleHeaderContainer = ({ active, manageParentStates }) => {
  const propName = "activeTab";

  return (
    <TabToggleHeader>
      <Tab
        onClick={() => {
          manageParentStates({ propName, value: "slide" });
        }}
        className={active === "slide" ? "active-tab" : ""}
      >
        <TabButton className={active === "slide" ? "active" : ""}>
          Slide
        </TabButton>
      </Tab>
      <Tab
        onClick={() => {
          manageParentStates({ propName, value: "group" });
        }}
        className={active === "group" ? "active-tab" : ""}
      >
        <TabButton className={active === "group" ? "active" : ""}>
          Groups
        </TabButton>
      </Tab>
      {featureFlags.presentation.showFilter && (
        <Tab
          onClick={() => {
            manageParentStates({ propName, value: "filter" });
          }}
          className={active === "filter" ? "active-tab" : ""}
        >
          <TabButton className={active === "filter" ? "active" : ""}>
            Filters
          </TabButton>
        </Tab>
      )}
    </TabToggleHeader>
  );
};

/**
 * Tab Container and buttons styles
 */
const TabToggleHeader = styled.ul`
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  overflow: hidden;
`;

const Tab = styled.li`
  box-sizing: border-box;
  width: ${featureFlags.presentation.showFilter ? "33.33%" : "50%"};
  display: inline-block;
  vertical-align: top;
  text-align: center;
  padding: 12px 0 0;
  background: ${props => props.theme.COLOR_PALLETE.SOLITUDE};
  box-shadow: inset 6px 0px 15px 0 rgba(0, 0, 0, 0.14);
  &.active-tab {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    box-shadow: none;
    background: ${props => props.theme.COLOR.WHITE};
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      height: 3px;
      width: 52px;
      border-radius: 5px;
      background: ${props => hexToRgba(props.theme.COLOR.USER_PRIMARY, 0.63)};
      transform: translateX(-50%);
    }
  }
  cursor: pointer;
`;

const TabButton = styled.button`
  width: 100%;
  padding-bottom: 9px;
  border: none;
  background: transparent;
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  outline: none;
  cursor: pointer;
  color: ${props => hexToRgba(props.theme.COLOR_PALLETE.BROWNISH_GREY, 0.4)};
  font-family: ${props => props.theme.FONT.REG};
  &.active {
    padding-bottom: 7px;
    font-weight: bold;
    color: ${props => props.theme.COLOR.MAIN};
    /* border-bottom: 2px solid ${hexToRgba("#215eff", 0.63)}; */
  }
`;

/**
 * //END
 * Tab Container and buttons styles
 */

export default TabToggleHeaderContainer;
